<script>
  import OverlayCard from "../components/overlayCard.svelte";
  import { card } from "../utils/portfolio.js";
  import { scroll } from "../store/parallax";
  // console.log(card);
</script>

<main class="px-8 md:space-y-0 space-y-4 mb:pb-0 pb-4">
  <h1 class="text-center text-4xl font-thin">Port<span class='font-semibold'>folio</span></h1>
  <div
    class="flex md:justify-around justify-end items-center flex-wrap md:my-12 md:py-0"
  >
    {#each card as params}
      <OverlayCard {...params} />
    {/each}
  </div>
</main>
